export enum PartyTypeCode {
  NATURAL_PERSON = 'NATURAL_PERSON',
  ORGANIZATION = 'ORGANIZATION',
  BUSINESS_ACTIVITY = 'BUSINESS_ACTIVITY'
}
